<div class="explanation-processing__container">
    <eb-spinner/>
</div>
